import * as z from "zod";

/**
 * Fixed trailing-30d alert catch rate — alerts ÷ (alerts + chargebacks), not
 * scoped by the dashboard date picker. Counts chargebacks of every payment method.
 */
export const getAlertCatchRate = {
  name: "getAlertCatchRate" as const,
  input: z.object({}),
  output: z.object({
    alertCountTrailing30d: z.coerce.number(),
    chargebackCountTrailing30d: z.coerce.number(),
    catchRateTrailing30d: z.number().nullable(),
    errors: z.array(z.string()).nullish(),
  }),
};
